"use client";

import React from "react";
import { OspIcons } from "@ospweb/sdk-ui/src/Icon/OspIcons";
import NextImage from "../../NextImage";
import PriceDisplay from "../../PriceDisplay";
import { PriceFormatResult } from "../../PriceDisplay/types";
import { ReportTokenInfoProps } from "./XPayReportTypes";

const TokenInfo: React.FC<ReportTokenInfoProps> = ({ data, type }) => {
  const { token, price } = data;
  const tokenPrice = price.current;
  if (!token.name) {
    return (
      <div className="flex items-center gap-2">
        <div className="w-[44px] h-[44px] rounded-full overflow-hidden bg-background_white_overlay10" />
        <div className="w-[88px] h-5 rounded-sm bg-background_white_overlay10" />
      </div>
    );
  }

  // 根据价格变化状态设置样式
  const changeStyles = {
    up: { className: "text-content_accent1_primary", icon: "upvote" },
    down: { className: "text-content_accent2_primary", icon: "downvote" },
    flat: { className: "text-content_secondary", icon: "" },
  };
  const currentStyle = changeStyles[price.change.status];

  return (
    <div className="flex items-center gap-3">
      <div className="w-14 h-14 max-md:h-11 max-md:w-11 border-[2px] border-border_solid rounded-full overflow-hidden">
        <NextImage
          className="w-full h-full object-cover rounded-full"
          src={token.avatarSrc}
          alt="avatar"
          loading="lazy"
          referrerPolicy="no-referrer"
        />
      </div>
      <div className="flex flex-col">
        <div className="flex items-center">
          <div className="text-content_primary max-md:body_medium_m body_medium_l">
            {token.name}
          </div>
        </div>
        <div className="flex gap-1 items-end">
          {type === "stock" && (
            <div className="headline_regular_m max-md:headline_regular_s text-content_primary">
              {price.currency}
              {price.current as string}
            </div>
          )}
          {type !== "stock" && (
            <PriceDisplay
              priceData={tokenPrice as PriceFormatResult}
              classNames={{
                container: "headline_regular_m text-content_primary",
                zeroCount: "body_medium_s",
              }}
            />
          )}
          <div className="flex items-center pb-0.5">
            {currentStyle.icon && (
              <OspIcons
                name={currentStyle.icon}
                size={12}
                className={currentStyle.className}
              />
            )}
            <div
              className={`body_bold_m max-md:body_medium_m ml-0.5 ${currentStyle.className}`}
            >
              {price.change.percentage}
            </div>
          </div>
          {price.label && (
            <div className="body_s ml-1 text-content_quaternary pb-0.5">
              {price.label}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TokenInfo;
